<div class="calendar-holder">
  <app-mini-event-calendar
    *ngIf="!isLoading; else loading"
    [selectedDate]="guestArrive"
    [events]="events"
    [clickable]="false"
  ></app-mini-event-calendar>

  <ng-template #loading>
    <div class="text-center loading-calendar">
      <span class="fal fa-spinner fa-spin"></span>
    </div>
  </ng-template>
</div>
